import { Outlet } from "react-router";

// shared guard doesn't check the authentication
const SharedGuard = () => {
  return <Outlet />;
};

export default SharedGuard;
